<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Your Saved Searches'"></app-st-header-title>
    </div>
  </div>
  <br>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <br>

  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button-delete-all *ngIf="!this.readOnly" [idVal]="'top-reset-filter-button1-id'" [label]="'Reset Filter'"
                                (click)="this.resetFilters()"></app-st-button-delete-all>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                      [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSubmit(false)"></app-st-button>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                      [idVal]="'top-save-and-apply-button-id'" [label]="'Save and Apply'" [primary]="true"
                     (click)="this.onSubmit(true)"></app-st-button>
    </div>
    <br>
    <div id="GRANT_SEARCH">
      <app-st-header-title [inputVal]="'Search Grants Filters Template'"></app-st-header-title>
      <div>
        <app-st-input-text [idVal]="'grant-search-filter-name-text-id'" [label]="''" [placeHolderVal]="'Grant Search Filter Name'"
                           [inputVal]="savedGrantSearchName" [width]="'90%'" [maxLength]="100"
                           [disabled]="this.readOnly"
        ></app-st-input-text>

        <br>
        <div>
          <button id="'grant-tax-years-button-id'" class="accordion webtext-black" (click)="this.toggleTaxYearsFilter()">Tax Years Based on Filing Status<b *ngIf="!this.grant_taxYearsButton"> + </b><b *ngIf="this.grant_taxYearsButton"> - </b></button>
        </div>
        <div *ngIf="this.grant_taxYearsButton" class="panel">
          <div class="accordion-body" *ngFor="let taxYearsRadioButton of this.grant_taxYearsRadioButtons; let i9 = index">
            <div class="form-check">
              <input class="form-check-input" type="radio" value="{{taxYearsRadioButton['taxYear']}}" id="flexRadioGrantTaxYears-{{i9}}"
                     (click)="trackTaxYears(i9)" [checked]="taxYearsRadioButton['checked']" [disabled]="this.readOnly">
              <label class="form-check-label checkbox-text webtext-black" for="flexRadioGrantTaxYears-{{i9}}">
                {{taxYearsRadioButton['taxYear']}}
              </label>
            </div>
          </div>
        </div>
        <br>
        <app-st-span [inputVal]="'Include Grant Names: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple included grant names by commas.'"></app-st-span>
        <app-st-input-text [idVal]="'grant-search-grant-names-text-id'" [label]="''" [placeHolderVal]="'Grant Names'" [width]="'95%'"
          [maxLength]="200" [disabled]="this.readOnly"
        ></app-st-input-text>
        <!--<app-st-autocomplete [idVal]="'grant-search-grant-names-text-id'" [label]="''" [placeHolderVal]="'Grant Names'" [maxLength]="200" [width]="'95%'"
                             [items]="this.recipientNamesAutocomplete"
        ></app-st-autocomplete>-->
        <!--<app-st-input-text [idVal]="'grant-state-text-id'" [label]="''" [placeHolderVal]="'State'" [inputVal]="grant_state" [width]="'95%'"></app-st-input-text>-->
        <br>
        <app-st-span [inputVal]="'Include EINs: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple eins by commas.'"></app-st-span>
        <app-st-input-text [idVal]="'eins-text-id'" [label]="''" [placeHolderVal]="'EINs'" [width]="'90%'"
                           [maxLength]="200" [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>
        <app-st-span [inputVal]="'Include Cities: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple included cities by commas.'"></app-st-span>
        <!--<app-st-input-text [idVal]="'cities-text-id'" [label]="''" [placeHolderVal]="'Cities'" [width]="'95%'"
                           [maxLength]="200"
        ></app-st-input-text>-->
        <app-st-autocomplete-key-lookup [idVal]="'cities-text-id'" [label]="''" [placeHolderVal]="'Include Cities'" [maxLength]="200" [width]="'95%'" [keyLookup]="'city'"
                                        [items]="this.citiesAutocomplete" [disabled]="this.readOnly"
        ></app-st-autocomplete-key-lookup>
        <br>
        <!--
        <app-st-span [inputVal]="'Exclude Cities: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple excluded cities by commas.'"></app-st-span>
        <app-st-input-text [idVal]="'cities-without-text-id'" [label]="''" [placeHolderVal]="'Without Cities'" [width]="'95%'"
                           [maxLength]="200" [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>-->

        <app-st-span [inputVal]="'State: '" class="webtext-black-bold"></app-st-span>
        <app-st-select *ngIf="!this.readOnly" [idVal]="'usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.grant_statesList"></app-st-select>
        <app-st-input-text  *ngIf="this.readOnly" [idVal]="'usa-state-text-id'" [label]="''" [placeHolderVal]="'State'"
                            [width]="'95%'" [disabled]="this.readOnly"></app-st-input-text>
        <br>
        <app-st-span [inputVal]="'Minimum Grant Amount: '" class="webtext-black-bold"></app-st-span>
        <app-st-input-text [idVal]="'grant-grant-amt-min-text-id'" [label]="''" [placeHolderVal]="'Min Grant Amount'" [inputVal]="grant_grantAmtMinStr" [width]="'46%'"
                           [maxLength]="20" [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>
        <app-st-span [inputVal]="'Maximum Grant Amount: '" class="webtext-black-bold"></app-st-span>
        <app-st-input-text [idVal]="'grant-grant-amt-max-text-id'" [label]="''" [placeHolderVal]="'Max Grant Amount'" [inputVal]="grant_grantAmtMaxStr" [width]="'46%'"
                           [maxLength]="20" [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>

        <!--Cause Dropdown triggers the Giving Interest Dropdown-->
        <div *ngIf="!this.readOnly">
          <app-st-span [inputVal]="'Cause Category: '" class="webtext-black-bold"></app-st-span><br>
          <app-st-select [idVal]="'cause-category-dropdown-list-id'" [defaultOption]="'Cause Category'" [label]="''" [idKey]="'causeId'" [displayKey]="'causeDisplayName'" [valueKey]="'causeName'" [inputArray]="this.causeDropdownList" (change)="updateCauseGivingInterestsDropdown()"></app-st-select>
          <br>
          <app-st-span [inputVal]="'Select the option of your search for the selected Cause Category Giving Interest: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="'AND'" id="flexRadioAND3"
                   (click)="trackLogicalExpression('AND')" [checked]="logicalOperatorAnd">
            <label class="form-check-label checkbox-text webtext-black" for="flexRadioAND3">
              &nbsp;AND
            </label>
            &nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="'OR'" id="flexRadioOR3"
                   (click)="trackLogicalExpression('OR')" [checked]="logicalOperatorOr">
            <label class="form-check-label checkbox-text webtext-black" for="flexRadioOR3">
              &nbsp;OR
            </label>
          </div>
          <!--Giving Interest Dropdown-->
          <app-st-span [inputVal]="'Select your Cause Category Giving Interest: '" class="webtext-black-bold"></app-st-span><br>

          <app-st-select [idVal]="'cause-giving-interests-dropdown-list-id'" [defaultOption]="'Select your Cause Category Giving Interest'" [label]="''" [idKey]="'causeGivingInterestId'" [displayKey]="'givingInterestDisplayName'" [valueKey]="'givingInterestName'" [inputArray]="this.causeGivingInterestsDropdownList"></app-st-select>
          <br>
          <div class="col2 d-grid gap-2 d-md-flex">
            <app-st-button [idVal]="'cause-giving-interests-include-button-id'" [label]="'Add (+)'" [primary]="true"
                           (click)="this.addCauseGivingInterestFilter2(true)"></app-st-button>
          </div>
        </div>
        <br>
        <i class="webtext-black" style="font-size: 12px;">As you add your Cause Category Giving Interests, the list below will populate.</i>
        <div>
          <table class="table table-striped webtext-black" style="width:95%; border-radius: 10px">
            <thead>
            <tr>
              <th style="width:85%">Cause Category Giving Interest Query</th>
              <th style="width:15%">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of this.grant_causeGivingInterestsList">
              <td>{{row}}</td>
              <td>
                <a *ngIf="('OR' != row) && ('AND' != row) && !this.readOnly" (click)="onDeleteGivingInterest(row)">
                  <i class="bi bi-trash"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--
        <div>
          <br>
          <div class="chip" *ngFor="let row of this.grant_causeGivingInterestsList">
            {{row}}
            <span class="closebtn-chip" (click)="this.deleteGivingInterestChip3(row)">&times;</span>
          </div>
        </div>-->
        <br>
        <br>
        <!--Exclude these cause_giving_interests-->
        <!--
        <div>
          <br>
          <table class="table table-striped webtext-black" style="width:95%">
            <thead>
            <tr>
              <th style="width:85%">Exclude these Cause Category Giving Interest(s)</th>
              <th style="width:15%">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of this.grant_causeGivingInterestsWithoutList">
              <td>{{row}}</td>
              <td>
                <a *ngIf="!this.readOnly" (click)="onDeleteGivingInterestWithout(row)">
                  <i class="bi bi-trash"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        -->
        <!--
        <div>
          <br>
          <div class="chip" *ngFor="let row of this.grant_causeGivingInterestsWithoutList">
            {{row}}
            <span class="closebtn-chip" (click)="this.deleteGivingInterestWithoutChip3(row)">&times;</span>
          </div>
        </div>-->
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By Recipient Name: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="recipient-name-asc-radio-button-id"
                   (click)="toggleRecipientNameAscButton()" [checked]="this.recipientNameAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="recipient-name-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="recipient-name-desc-radio-button-id"
                   (click)="toggleRecipientNameDescButton()" [checked]="this.recipientNameDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="recipient-name-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By City: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-asc-radio-button-id"
                   (click)="toggleCityAscButton()" [checked]="this.cityAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="city-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-desc-radio-button-id"
                   (click)="toggleCityDescButton()" [checked]="this.cityDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="city-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By State: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-asc-radio-button-id"
                   (click)="toggleStateAscButton()" [checked]="this.stateAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="state-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-desc-radio-button-id"
                   (click)="toggleStateDescButton()" [checked]="this.stateDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="state-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By Grant Amount: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="grant-amt-asc-radio-button-id"
                   (click)="toggleGrantAmountAscButton()" [checked]="this.grantAmountAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="grant-amt-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="grant-amt-desc-radio-button-id"
                   (click)="toggleGrantAmountDescButton()" [checked]="this.grantAmountDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="grant-amt-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
      </div>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
      <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
      <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
        <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
      </div>
      <br>
    </div>
    <br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button-delete-all *ngIf="!this.readOnly" [idVal]="'top-reset-filter-button2-id'" [label]="'Reset Filter'"
                                (click)="this.resetFilters()"></app-st-button-delete-all>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                      [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSubmit(false)"></app-st-button>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                    [idVal]="'top-save-and-apply-button-id'" [label]="'Submit and Apply'" [primary]="true"
                     (click)="this.onSubmit(true)"></app-st-button>
    </div>

  </div>
</div>
